<template>
    <div id="page" :class="[isLight ? 'lightmode' : 'darkmode']">
        <div v-if="isMenuShown" class="darker-film" @click="toggleMenuMobile"></div>
        <sidebar-navigator @change-theme="changeTheme" 
                        @toggle-menu-mobile="toggleMenuMobile" 
                        @change-calc="changeCalc" 
                        :menu-shown="isMenuShown"
                        :dark-mode="isLight"
                        :selected-calc="selectedCalc"/>
        <navigation-bar @toggle-menu-mobile="toggleMenuMobile" @change-theme="changeTheme" :dark-mode="isLight"/>
        <main :class="[isLight ? 'lightmode' : 'darkmode']">
            <article>
                <h1>Untitled 9</h1>
                <p>The Time Calculator is created by Untitled 9, a personal software development project of Ciprian Corobca.</p>
                <p>You may find other Untitled 9 products <a href="https://cipriancorobca.github.io" target="_blank">here</a></p>
            </article>
        </main>
        <info-footer />
    </div>
</template>

<script setup>
  import { ref,computed,onMounted, onUnmounted } from "vue";
  import SidebarNavigator from "./SidebarNavigator.vue";
  import InfoFooter from "./InfoFooter.vue";
  import NavigationBar from "./NavigationBar.vue";
  import { timeCalculatorSettings } from "@/stores/TimeCalculatorStore";

  var isLight = computed(() => timeCalculatorSettings().lightMode);
  var isMenuShown = ref(false);

  const changeTheme = () =>
  {
    timeCalculatorSettings().changeTheme();
  }

  const toggleMenuMobile = () =>
  {
    isMenuShown.value = !isMenuShown.value;

    if(isMenuShown.value)
    {
      document.body.classList.add('menu-shown');
    }

    else
    {
      document.body.classList.remove('menu-shown');
    }
  }

  const changeToDesktop = () =>
  {
    if (window.innerWidth > 770) 
    {
        isMenuShown.value = false;
        document.body.classList.remove('menu-shown');
    }
  }

  onMounted(() => 
  {
    changeToDesktop();
    window.addEventListener('resize',changeToDesktop);
    document.body.classList.remove('menu-shown');
  });

  onUnmounted(() =>
  {
    window.removeEventListener('resize',changeToDesktop);
    document.body.classList.remove('menu-shown');
  });
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Syne');
  [id]
  {
    scroll-margin-top: 70px;
  }
  
  #page
  {
    display: grid;
    min-height:100dvh;
    width:100vw;
    padding:0;
    margin:0;
    grid-template-columns: 1fr;
    grid-template-rows:67px auto 50px;
  }

  #page.lightmode
  {
    background-color: #F0F0F0;
  }

  #page.darkmode
  {
    background-color: #2b3133;
  }

  .darker-film
  {
    grid-area: 1 / 1 / -1 / 2;
    z-index:6;
    background-color: rgba(128, 128, 128, 0.4);
    transition: 0.1s all;
  }

  h1
  {
    margin-bottom:0;
    font-size: clamp(medium,10vw,xx-large);
  }

    main
    {
        grid-area: 2 / 1 / 3 / 2;
        font-family: Syne;
        display:flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        justify-self:center;
        flex-grow: 1;
        width:92%;
        height:fit-content;
        max-width: 600px;
        padding:1.333% 2%;
        margin:15px auto;
        border-radius: 12px;
    }

    main.lightmode
    {
        background-color: #F7F7F6;
        color:#2b3133;
        box-shadow:#2b3133 0px 1px 7px 1px;
        -webkit-box-shadow:#2b3133 0px 1px 7px 1px;
    }

    main.darkmode
    {
        background-color: #2b3133;
        color: #F7F7F6;
        box-shadow:rgb(50, 142, 110) 0px 1px 7px 1px;
        -webkit-box-shadow:rgb(50, 142, 110) 0px 1px 7px 1px;
    }

    table
    {
        font-size: clamp(8px,4.5vw,20px);
    }

    table,th,td
    {
        border:1px solid;
        border-collapse: collapse;
    }

    table.lightmode,th.lightmode,td.lightmode
    {
        border-color: #2b3133;
    }

    table.darkmode,th.darkmode,td.darkmode
    {
        border-color: #F7F7F6;
    }

    a,a:visited
    {
        color:#328E6E;
    }

  @media screen and (min-width: 770px)
  {
    #page
    {
      width: 100vw;
      grid-template-columns: 100vw;
    }
  }
</style>